import React from 'react';
import ReactLoading from 'react-loading';

const loaderHeight = 100;
const loaderWidth = 100;

const Loading = () => {
    const table = document.getElementsByClassName('table');
    const cards = document.getElementsByClassName('card-header');
    let marginTop = 0;

    if (cards.length > 0) {
        let cardArr = Array.from(cards);

        cardArr = cardArr.slice(0, cardArr.length - 1);
        cardArr.forEach((element) => {
            marginTop += element.clientHeight;
        });
    }

    if (table.length > 0) {
        let th = table[0].children[1];
        let thHeight = th.clientHeight;

        marginTop += thHeight;
    }

    return (
        <div>
            <div className='d-flex justify-content-center w-100' />
            <div style={{ position: 'fixed', zIndex: 1000, opacity: 1, marginTop: marginTop }} className='d-flex justify-content-center w-100'>
                <ReactLoading type={'bars'} color={'#262f3d'} height={loaderHeight} width={loaderWidth} />
            </div>
        </div>
    );
};

export default Loading;

